import { data } from '../../svg/Sync/data';
import { makeIcon } from '../makeIcon';

export const Sync = makeIcon(data, 'sync', 'Sync');

export default Sync;
